import { mix } from "@chorda/core";
export const Select = (props) => {
    return mix({
        tag: 'span',
        css: 'select',
        templates: {
            content: {
                tag: 'select',
                defaultItem: {
                    tag: 'option'
                },
            }
        }
    }, props && {
        classes: {
            'is-fullwidth': props.fullwidth
        },
        templates: {
            content: {
                items: props.options
            }
        }
    });
};
export const Option = (props) => {
    return {
        tag: 'option',
        text: props.text
    };
};
